<template>
  <div :class="$style.root">
    <div
      v-for="n in total" 
      :key="n" 
      :class="computeStepClass(n)" 
      :style="computeStepStyle(n)"
    >
      {{ n }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 10,
    },
    current: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
    },
    bgColor: {
      type: String,
    },
    activeBgColor: {
      type: String,
      default: '#ffffff6b',
    },
    borderColor: {
      type: String,
      default: '#00000030',
    },
    activeBorderColor: {
      type: String,
      default: '#00000059',
    },
  },
  computed: {
  },
  methods: {
    computeStepClass (n) {
      return [this.$style.step, {
        [this.$style.step_previous]: this.current > n,
        [this.$style.step_current]: this.current == n,
        [this.$style.step_next]: this.current < n,
      }]
    },
    computeStepStyle (n) {
      const isCurrent = this.current == n
      return {
        'color': this.color,
        'border-color': isCurrent ? this.activeBorderColor : this.borderColor,
        'background-color': isCurrent ? this.activeBgColor : this.bgColor,
      }
    },
  },
}
</script>

<style lang="scss" module>
$size: 1.5rem;

.root {
  @apply flex;
  @apply justify-center;
  @apply absolute;
  @apply top-0;
  @apply inset-x-0;
}

.step {
  width: $size;
  height: $size;
  line-height: $size;
  @apply m-2;
  @apply rounded-full;
  @apply text-center;
  border: 2px solid transparent;
  @apply relative;
  transition: all .2s;

  &::after {
    content: '';
    @apply absolute;
    @apply inset-0;
    @apply rounded-full;
    background-color: #000000;
    opacity: 0;
    transition: all .2s;
  }
}

.step_current {
  transform: scale(1.4);
}

.step_previous {
  //
}

.step_next {
  &::after {
    opacity: 0.2;
  }
}
</style>
